import { Stack } from "@mui/material";
import CustomDialog from "components/CustomDialog";
import CustomDataGrid from "components/customDataGrid";
import { DATE_TIME_FORMAT } from "config/const";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import moment from "moment";

const ServiceCallDetails = ({ data, setData, dialogTitle }) => {
    const { bt } = useBizTypeTranslation();
    const onClose = () => { setData(null) };

    return (
        <CustomDialog width={600} open={data ? true : false} onClose={onClose} title={dialogTitle}>
            <Stack>
                <CustomDataGrid
                    maxHeight={450}
                    minHeight={450}
                    borderRadius="10px 10px 10px 10px"
                    columns={[
                        {
                            field: "callId",
                            headerName: bt("CALL_ID"),
                            filterable: true,
                            width: 100,
                        },
                        {
                            field: "clienCompany",
                            headerName: bt("BIZ_NAME"),
                            filterable: true,
                            width: 120,
                        },
                        {
                            field: "employeeName",
                            headerName: bt("EMPLOYEE_NAME"),
                            filterable: true,
                            width: 120,
                            valueFormatter: (params) => params ? params : bt("NO_EMPLOYEE")
                        },
                        {
                            field: "workDt",
                            headerName: bt("WORK_DT"),
                            filterable: true,
                            width: 120,
                            valueFormatter: (params) => params
                                ? moment(params).format(DATE_TIME_FORMAT)
                                : "",
                        },
                    ]}
                    list={data?.map((item) => ({
                        ...item,
                        id: item._id,
                        employeeName: `${item?.employee?.fn} ${item?.employee?.ln}`,
                        clienCompany: item?.clienCompany
                            ? item?.clienCompany
                            : item?.name,
                    })) ?? []
                    }
                />

            </Stack>
        </CustomDialog>
    );
};
export default ServiceCallDetails;